import React from 'react'
import _ from "lodash";
import {COLOR_LIST} from "../../../../common/constants/color.constant";
import ClearButton from "../../../../common/ui/clear-button";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

const EditColorDetails = ({displayTextItem, handleColorDetailsChanges, handleClearColor}) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    return (
        <>

            <div className="ml-2 field-label">
                Text Color & Shade
            </div>

            <div className="flex justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <select
                            className="input-field"
                            id="colorKey"
                            name="colorKey"
                            value={displayTextItem?.colorKey}
                            onChange={(event) => {
                                handleColorDetailsChanges(event, displayTextItem);
                            }}>
                            <option value="">Choose Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="field-container">
                        <select
                            className="input-field"
                            id="colorCodeKey"
                            name="colorCodeKey"
                            value={displayTextItem?.colorCodeKey}
                            onChange={(event) => {
                                handleColorDetailsChanges(event, displayTextItem);
                            }}>
                            <option value="">Choose Shade</option>
                            {colorMap[displayTextItem?.colorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                    <ClearButton handleClear={(event) => {
                        handleClearColor(event, displayTextItem);
                    }}/>
                </div>
            </div>

        </>
    )
}

export default EditColorDetails
